import React from "react";

function TorchImage(props) {
    return (
        <svg
            version="1.1"
            id="Capa_1"
            x="0px"
            y="0px"
            width="200px"
            height="200px"
            viewBox="0 0 32 32"
            fill={props.color}
        >
            <g>
                <g>
                    <path
                        d="M18.997,11.692h-6.119l1.932,9.603l0.159,4.964l-0.573,3.134h0.012c-0.007,0.059-0.012,0.117-0.012,0.18
			   c0,0.851,1.543,2.428,1.543,2.428s1.541-1.577,1.541-2.43c0-0.057-0.004-0.117-0.011-0.18h0.011l-0.504-3.064l0.076-4.864
			   L18.997,11.692z"
                    />
                    <path
                        d="M19.269,7.188c-0.041-0.186-0.105-0.344-0.168-0.487c-0.129-0.278-0.266-0.478-0.359-0.623
			   c-0.041-0.072-0.084-0.131-0.105-0.172c-0.025-0.043-0.038-0.064-0.038-0.064s-0.011,0.023-0.026,0.07
			   c-0.015,0.047-0.039,0.117-0.053,0.207c-0.014,0.09-0.029,0.199-0.039,0.32c-0.006,0.118-0.015,0.249-0.023,0.393
			   c-0.012,0.137-0.019,0.279-0.041,0.417c-0.016,0.14-0.051,0.27-0.09,0.389c-0.041,0.119-0.104,0.217-0.166,0.315l-0.043,0.053
			   c-0.016,0.016-0.02,0.031-0.061,0.071l-0.1,0.102L17.95,8.185l-0.004,0.003L17.933,8.2l-0.051,0.046
			   c-0.135,0.127-0.266,0.252-0.398,0.387c-0.131,0.128-0.26,0.27-0.381,0.411c-0.12,0.142-0.232,0.294-0.33,0.445
			   c-0.094,0.159-0.18,0.306-0.233,0.464c-0.027,0.077-0.056,0.147-0.076,0.219c-0.015,0.076-0.03,0.146-0.04,0.213
			   c-0.01,0.067-0.021,0.127-0.023,0.182c0,0.055,0.005,0.103,0.007,0.146c0.003,0.088,0.017,0.16,0.021,0.207
			   c0.008,0.049,0.012,0.074,0.012,0.074s0.018-0.02,0.051-0.055c0.029-0.037,0.08-0.09,0.132-0.16
			   c0.027-0.035,0.056-0.075,0.09-0.115c0.038-0.033,0.074-0.071,0.114-0.109c0.039-0.037,0.076-0.077,0.115-0.117
			   c0.047-0.039,0.094-0.08,0.145-0.123c0.09-0.087,0.211-0.168,0.324-0.259c0.122-0.09,0.251-0.185,0.385-0.282
			   c0.069-0.049,0.139-0.102,0.209-0.156c0.069-0.053,0.146-0.109,0.217-0.168c0.146-0.111,0.29-0.243,0.435-0.371l0.055-0.05
			   l0.052-0.052l0.021-0.027l0.094-0.104c0.027-0.025,0.074-0.09,0.113-0.148c0.041-0.06,0.082-0.121,0.115-0.179
			   c0.055-0.116,0.112-0.228,0.141-0.35c0.039-0.118,0.059-0.236,0.068-0.353C19.335,7.587,19.313,7.372,19.269,7.188z M17.933,8.204
			   l-0.004,0.003c0.004-0.004,0.004-0.004,0.007-0.007L17.933,8.204z"
                    />
                    <path
                        d="M12.95,7.846c0.026,0.056,0.069,0.134,0.108,0.207c0.158,0.272,0.333,0.51,0.52,0.729C13.763,9,13.958,9.193,14.15,9.372
			   c0.383,0.355,0.756,0.645,1.059,0.895c0.305,0.249,0.538,0.463,0.664,0.647c0.063,0.092,0.1,0.174,0.121,0.235
			   c0.017,0.063,0.025,0.097,0.025,0.097s0.016-0.031,0.039-0.097c0.016-0.065,0.045-0.171,0.03-0.305
			   c-0.011-0.133-0.044-0.296-0.11-0.466c-0.064-0.171-0.156-0.352-0.267-0.537c-0.221-0.371-0.515-0.758-0.819-1.15
			   c-0.151-0.195-0.304-0.396-0.45-0.595c-0.142-0.2-0.286-0.403-0.396-0.602c-0.121-0.211-0.199-0.38-0.25-0.58
			   c-0.027-0.098-0.043-0.202-0.06-0.307c-0.01-0.107-0.02-0.214-0.022-0.325c-0.011-0.441,0.051-0.897,0.09-1.307
			   c0.041-0.408,0.06-0.78-0.004-1.045c-0.027-0.132-0.084-0.229-0.133-0.284c-0.047-0.053-0.08-0.065-0.078-0.068
			   c-0.003,0,0.014,0.035,0.021,0.099c0.008,0.057-0.003,0.147-0.035,0.252c-0.066,0.212-0.227,0.5-0.402,0.872
			   c-0.174,0.374-0.375,0.836-0.461,1.41c-0.043,0.285-0.052,0.601,0.006,0.926c0.028,0.162,0.069,0.326,0.133,0.484L12.9,7.74
			   L12.95,7.846z"
                    />
                    <path
                        d="M15.403,8.49c-0.136-1.756,1.34-2.188,0.647-3.657c1.709,1.365,0.207,3.892,0.207,3.892s1.662-0.873,1.77-2.717
			   c0.108-1.844-1.969-3.032-2.758-3.604C14.479,1.832,15.208,0,15.208,0s-1.076,1.163-1.112,2.44s0.187,1.888,0.68,2.726
			   C15.268,6.004,15.073,6.961,15.403,8.49z"
                    />
                </g>
            </g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
        </svg>
    );
}

export default TorchImage;
